import { ReactNode } from 'react'

import { AppButton } from '@/components/shared/button'
import { AppModal } from '@/components/shared/modal'

type Props = {
  headerText: string
  text?: ReactNode
  visible: boolean
  setVisibility: (visible: boolean) => void
  dark?: boolean
}

const InfoModal = ({
  visible,
  setVisibility,
  headerText,
  text,
  dark
}: Props) => (
  <AppModal
    overlayClassName="!bg-black/50"
    className="w-[387px] sm:!h-auto sm:!w-[295px] sm:!rounded-16"
    header={headerText}
    opened={visible}
    onClose={() => setVisibility(false)}
  >
    {text && <p className="text-grey-70 text-20 sm:text-16">{text}</p>}
    <AppButton
      variant={dark ? 'secondary' : 'primary'}
      className="mt-20 w-full"
      onClick={() => setVisibility(false)}
    >
      Понятно
    </AppButton>
  </AppModal>
)

export default InfoModal
